{
  "until": "{{prayer}} পর্যন্ত {{duration}}",
  "begin_focus": "ফোকাস শুরু",
  "add_task": "কাজ যোগ করুন",
  "more_tasks": "+{{count}} আরও",
  "fajr_at": "ফজর {{time}}-এ",
  "schedule_title": "আজ",
  "plan_my_day": "আমার দিন সাজান",
  "planning": "পরিকল্পনা হচ্ছে…",
  "suggested": "প্রস্তাবিত",
  "keep_plan": "পরিকল্পনা রাখুন",
  "undo_plan": "ফিরিয়ে নিন",
  "plan_error": "এখন পরিকল্পনা করা গেল না। আবার চেষ্টা করুন।",
  "plan_empty": "এখনও পরিকল্পনার কিছু নেই — আগে একটি কাজ যোগ করুন।",
  "plan_settled": "সবকিছু ইতিমধ্যে নিজের জায়গায় আছে।",
  "view_list": "তালিকা",
  "view_switch_aria": "তালিকা ও দিনের দৃশ্যের মধ্যে পরিবর্তন করুন",
  "unassigned": "অনির্ধারিত",
  "assign_title": "নামাজের ব্লক",
  "no_block": "কোনো ব্লক নয়",
  "assign_aria": "একটি নামাজের ব্লকে যুক্ত করুন",
  "open_schedule_aria": "আজকের সূচি খুলুন",
  "focus_session_label": "{{block}} · ফোকাস",
  "block_hero": "{{prayer}} পর্যন্ত গভীর কাজ",
  "moments_away": "{{prayer}} কিছুক্ষণের মধ্যেই",
  "block_clear": "সব শেষ — {{prayer}} পর্যন্ত বিশ্রাম নিন",
  "alhamdulillah": "আলহামদুলিল্লাহ",
  "exit_hint": "চুপচাপ বেরোতে Esc চাপুন",
  "exit_hint_touch": "চুপচাপ বেরোতে ✕ চাপুন",
  "mark_done_aria": "কাজ সম্পন্ন হিসেবে চিহ্নিত করুন",
  "quick_add_placeholder": "এই ব্লকে যোগ করুন…",
  "focus_task_aria": "এই কাজে ফোকাস করুন"
}
